export const FiltersIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.4836 4H5.51636C4.17277 4 3.48535 5.62354 4.45399 6.5602L9.51591 11.6182V16.9883C9.51591 17.4879 9.73463 17.925 10.1096 18.2372L12.1094 19.7359C13.078 20.3915 14.5153 19.7671 14.5153 18.5182V11.6182L19.546 6.5602C20.5147 5.62354 19.8272 4 18.4836 4ZM13.0155 10.9937V18.487L11.0157 16.9883V10.9937L5.51636 5.49865H18.5149L13.0155 10.9937Z"
      fill="#292B29"
    />
  </svg>
);
